import CheckBoxResultField from "@/components/Calculator/Components/CheckBoxResultField/checkBoxResultField.component";
import ResultField from "@/components/Calculator/Components/ResultField/resultField.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import {
    CorrugatedSheetShoppingList,
    OndulineProductTileModel
} from "../corrugatedSheetCalculator.types";

type CorrugatedSheetShoppingListComponentProps = {
    result: CorrugatedSheetShoppingList;
    toggleAcc: (acc: OndulineProductTileModel) => void;
    activeAcc: Array<OndulineProductTileModel>;
};

const CorrugatedSheetShoppingListComponent = ({
    result,
    toggleAcc,
    activeAcc
}: CorrugatedSheetShoppingListComponentProps) => {
    const { t } = useGranite();
    const { fixture, sheet, accessories } = result;

    if (!fixture || !sheet || result.hasSlopeWarning) {
        return null;
    }

    const sortedAccessories: Array<OndulineProductTileModel> = [];

    accessories.forEach((acc) => {
        if (acc.dependsOn) {
            const parentIndex = accessories.findIndex(
                (a) => a.sku === acc.dependsOn
            );
            if (parentIndex > -1) {
                sortedAccessories.splice(parentIndex + 1, 0, acc);
            }
        } else {
            sortedAccessories.push(acc);
        }
    });

    return (
        <div id="shopping-list">
            <Row>
                <ResultField
                    sm={12}
                    md={8}
                    lg={6}
                    copy={sheet.title}
                    copyPostfix={
                        <>
                            {sheet.itemsPerPackage > 1 && (
                                <>
                                    {t(
                                        "calculator.corrugatedSheetCalculator.numberOfSheets.package",
                                        sheet.itemsPerPackage
                                    )}
                                    <br />
                                </>
                            )}
                            {t(
                                "calculator.corrugatedSheetCalculator.numberOfSheets.note"
                            )}
                        </>
                    }
                    value={sheet.amount.toFixed(0)}
                />
            </Row>
            <Row>
                <ResultField
                    sm={12}
                    md={8}
                    lg={6}
                    copy={fixture.title}
                    copyPostfix={
                        fixture.itemsPerPackage > 1 && (
                            <>
                                {t(
                                    "calculator.corrugatedSheetCalculator.numberOfFixture.package",
                                    fixture.itemsPerPackage
                                )}
                                <br />
                            </>
                        )
                    }
                    value={fixture.amount.toFixed(0)}
                />
            </Row>
            {sortedAccessories.length > 0 && (
                <Row>
                    <Col>
                        <h3>
                            {t(
                                "calculator.corrugatedSheetCalculator.accessoiries.title"
                            )}
                        </h3>
                        <p>
                            {t(
                                "calculator.corrugatedSheetCalculator.accessoiries.description"
                            )}
                        </p>
                    </Col>
                </Row>
            )}
            {sortedAccessories.map((acc) => (
                <Row key={acc.sku}>
                    <CheckBoxResultField
                        sm={12}
                        md={8}
                        lg={6}
                        copy={acc.title}
                        value={acc.amount.toFixed(0)}
                        onCheck={() => toggleAcc(acc)}
                        isChecked={activeAcc.some((a) => a.sku === acc.sku)}
                        isDependent={!!acc.dependsOn}
                    />
                </Row>
            ))}
        </div>
    );
};

export { CorrugatedSheetShoppingListComponent };
